import { StepperInput } from '@/components/ui/stepper-input';
import type { CampaignEvent } from './types';

interface EventRowProps {
  event: CampaignEvent;
  places: number | undefined;
  error?: string;
  onToggle: () => void;
  onPlacesChange: (value: number) => void;
}

function formatStartsAt(startsAt: string | null): string | null {
  if (!startsAt) return null;
  const date = new Date(startsAt);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function EventRow({ event, places, error, onToggle, onPlacesChange }: EventRowProps) {
  const checked = places !== undefined;
  const startsAt = formatStartsAt(event.startsAt);

  return (
    <div>
      <div
        className={`flex items-center justify-between gap-3 px-3 py-2.5 rounded-lg border bg-black/40 text-sm sm:text-base ${
          error ? 'border-red-500' : 'border-white/10'
        } ${event.disabled ? 'opacity-50' : ''}`}
      >
        <label
          className={`flex items-center gap-3 min-w-0 ${event.disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <input
            type="checkbox"
            checked={checked}
            disabled={event.disabled}
            onChange={onToggle}
            className="h-4 w-4 rounded border-white/20 bg-black/50 accent-white"
          />
          <div className="flex flex-col min-w-0">
            <span className="text-white break-words">{event.name}</span>
            {startsAt && <span className="text-xs text-white/60">{startsAt}</span>}
            {event.disabled && event.disabledReason && (
              <span className="text-xs text-red-300">{event.disabledReason}</span>
            )}
          </div>
        </label>
        {checked && (
          <StepperInput
            value={places}
            onChange={onPlacesChange}
            min={1}
            max={event.maxPlaces ?? undefined}
            className="shrink-0"
          />
        )}
      </div>
      {error && <p className="text-red-400 text-xs sm:text-sm mt-1">{error}</p>}
    </div>
  );
}
